import axios, { microServices } from './axios'
import { loaders } from './../constants'

// // ********************API url *******************/project-type/:id
const GLOBAL_SETTING = '/global-setting'
const EDIT_GLOBAL_SETTING = '/global-setting/edit'
const DELETE_GLOBAL_SETTING = '/global-setting'
const EDIT_PROJECT_TYPE_SETTING = '/global-setting/edit/project-type'
const UPDATE_PROJECT_TYPE = '/project/project-type'
const EXPORT_ACCOUNT_DATA = '/global-setting/export'
const IMPORT_ACCOUNT_DATA = '/global-setting/import'

// // ************API call Functions starts here **************

export const getGlobalSetting = async (id) => {
    return await axios('get', `${GLOBAL_SETTING}/${id}`, {}, { loader: loaders.OVERLAY, server: microServices.DE_CORE }).then(data => {
        return data
    },
        error => { // request level error
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
}

export const editGlobalSetting = async (data, id) => {
    return await axios('put', `${EDIT_GLOBAL_SETTING}/${id}`, data, { loader: loaders.OVERLAY, successMessage: 'Global Setting Updated Successfully', server: microServices.DE_CORE }).then(data => {
        return data
    },
        error => { // request level error
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
}

export const deleteGlobalSetting = async (data, id) => {
    return await axios('delete', `${DELETE_GLOBAL_SETTING}/${id}/${data}`, {}, { loader: loaders.OVERLAY, successMessage: 'Global Setting Deleted Successfully', server: microServices.DE_CORE }).then(data => {
        return data
    },
        error => { // request level error
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
}

export const editProjectTypeSetting = async (data, id) => {
    return await axios('put', `${EDIT_PROJECT_TYPE_SETTING}/${id}`, data, { loader: loaders.OVERLAY, successMessage: 'Global Settings Updated Successfully', server: microServices.DE_CORE }).then(data => {
        return data
    },
    error => { // request level error
        return new Promise((resolve, reject) => {
            reject(error)
        })
    })
}

export const UpdateProjectType = async (data, id) => {
    return await axios('put', `${UPDATE_PROJECT_TYPE}/${id}`, data, { loader: loaders.OVERLAY, server: microServices.DE_CORE }).then(data => {
        return data
    },
    error => { // request level error
        return new Promise((resolve, reject) => {
            reject(error)
        })
    })
}

export const exportAccountData = async (data) => {
    return await axios('post', `${EXPORT_ACCOUNT_DATA}`, data, {
        server: microServices.DE_CORE
    }).then(response => {
        return response;
    }).catch(error => {
        console.error('Export request failed:', error);
        throw error;
    });
}

export const checkAccountExportStatus = async (data) => {
    return await axios('get', `${EXPORT_ACCOUNT_DATA}/status/${data.account_id}`, {}, {
        server: microServices.DE_CORE
    }).then(response => {
        return response;
    }).catch(error => {
        console.error('Export status check failed:', error);
        throw error;
    });
}

export const downloadAccountExport = async (data) => {
    try {
        const response = await axios('get', `${EXPORT_ACCOUNT_DATA}/download/${data.account_id}`, {}, {
            loader: loaders.OVERLAY,
            server: microServices.DE_CORE
        });
        
        if (response && response.status === 'SUCCESS') {
            const { url, filename } = response;
            if (url) {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename || `account_export_${data.account_id}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
        return response;
    } catch (error) {
        console.error('Export download failed:', error);
        throw error;
    }
}

export const importAccountData = async (file, account_id) => {
    try {
        // Create FormData object to handle the file upload
        const formData = new FormData();
        formData.append('import_file', file);
        formData.append('account_id', account_id);
        
        // Use the special formData config in the axios wrapper
        return await axios('post', IMPORT_ACCOUNT_DATA, formData, {
            loader: loaders.OVERLAY,
            successMessage: 'Account data import started',
            server: microServices.DE_CORE,
            formData: true  // This signals to the axios wrapper to handle FormData
        });
    } catch (error) {
        console.error('Import request failed:', error);
        throw error;
    }
}

export const checkAccountImportStatus = async (account_id) => {
    try {
        return await axios('get', `${IMPORT_ACCOUNT_DATA}/status/${account_id}`, {}, {
            server: microServices.DE_CORE
        });
    } catch (error) {
        console.error('Import status check failed:', error);
        throw error;
    }
}
